var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"primary fluid py-5 mt-12",staticStyle:{"max-width":"100%"}},[_c('p',{staticClass:"text-center font-weight-bold mb-0"},[_vm._v("SOLICITUD DE CRÉDITO CON MICROWD")])])}
var staticRenderFns = []

export { render, staticRenderFns }